import React, { useState } from "react";
import { Card, CardBody, Button } from "reactstrap";
import moment from "jalali-moment";
import { List, Tooltip, Avatar, Divider, Badge } from "antd";
import SupporterIcon from "./icons/supporter.png";
import UserIcon from "./icons/user2.png";
import { toast } from "react-toastify";
import useFetch from "../../Controllers/useFetch";
import Loader from "../../Loader";
import Axios from "axios";
import { baseUrl } from "../../Controllers/rest_api_config";
import { useSelector } from "react-redux";
// import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import toolbar from "./toolbar";
import { gql, useMutation, useQuery } from "@apollo/client";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ReturnBtnComponent from "./returnBtn";
import Cookies from "js-cookie";
import MassageComponent from "./Message";

const TICKET_SCHEMA = gql`
  query ($ticket_id: Int) {
    GetTicket(ticket_id: $ticket_id) {
      categorie
      content
      created
      source
      status
      ticket_id
      user_id
      user {
        ticket_id
        user_id
        User {
          firstname
          lastname
          role
        }
      }
    }
  }
`;
const CREATE_TICKET = gql`
  mutation Mutation($ticketInput: TicketInput) {
    CreateTicket(TicketInput: $ticketInput) {
      title
      content
      categorie
      created
      status
      source
      ticket_id
      user_id
    }
  }
`;

const findAuthor = (item) => {
  // console.log(item[0].User.role === "admin")
  if (item.length > 1 || item[0].User.role === "admin") return SupporterIcon;
  else return UserIcon;
};

const Ticket = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [contentState, setContentState] = useState();
  const user_role = Cookies.get("user_role");
  const { data, loading, refetch } = useQuery(TICKET_SCHEMA, {
    variables: {
      ticket_id: parseInt(window.location.hash.split("/")[2]),
    },
  });
  const [createTicket] = useMutation(CREATE_TICKET, {
    onCompleted: (res) => {
      // console.log(res);
      toast.success("پاسخ شما باموفقیت ارسال شد!");
      refetch({ ticket_id: parseInt(window.location.hash.split("/")[2]) });
      setContentState("");
    },
    onError: (err) => {
      // console.log(err);
      toast.error("مشکلی در ثبت پاسخ رخ داده است!");
    },
  });

  const findStatus = (status) => {
    switch (status) {
      case "open":
        return (
          <Badge
            status="success"
            text={lang_choiced.pages.tickets.ticket.header.status.selectors[0]}
          />
        );
      case "closed":
        return (
          <Badge
            status="error"
            text={lang_choiced.pages.tickets.ticket.header.status.selectors[1]}
          />
        );
      case "answered":
        return (
          <Badge
            status="processing"
            text={lang_choiced.pages.tickets.ticket.header.status.selectors[2]}
          />
        );
      default:
        return (
          <Badge
            status="warning"
            text={lang_choiced.pages.tickets.ticket.header.status.selectors[3]}
          />
        );
    }
  };

  // console.log(parseInt(window.location.hash.split("/")[2]), data, loading);
  const createUserName = (item) => {
    if (item.user.length > 1) return `Admin`;
    else return `${item.user[0].User.firstname} ${item.user[0].User.lastname}`;
  };

  if (loading) return <Loader />;
  else {
    // console.log(findStatus(data.GetTicket[0].status),data.GetTicket[0].status)
    return (
      <div className="animated fadeIn">
        <Card>
          <CardBody>
            <div className="text-left m-2">
              <ReturnBtnComponent />
            </div>
            <div>
              <CardBody>
                <List
                  className="comment-list"
                  header={
                    <div>
                      {`${data.GetTicket.length} ${lang_choiced.pages.tickets.ticket.header.counter}`}{" "}
                      <Divider type="vertical" />{" "}
                      {`${
                        lang_choiced.pages.tickets.ticket.header.created_time
                      } ${
                        window.document.documentElement.lang === "fa"
                          ? moment(new Date(data.GetTicket[0].created))
                              .locale("fa")
                              .format("HH:mm jYYYY/jMM/DD")
                          : moment(new Date(data.GetTicket[0].created))
                              .locale("en")
                              .format("HH:mm YYYY/MM/DD")
                      }`}{" "}
                      <Divider type="vertical" />{" "}
                      {
                        lang_choiced.pages.tickets.ticket.header.status
                          .selectors[0]
                      }{" "}
                      {findStatus(data.GetTicket[0].status)}
                      <Divider type="vertical" />{" "}
                      {lang_choiced.pages.tickets.ticket.header.sender}
                      {createUserName(data.GetTicket[0])}
                    </div>
                  }
                  itemLayout="horizontal"
                  dataSource={data.GetTicket}
                  renderItem={(item) => {
                    return (
                      <MassageComponent
                        item={item}
                        createUserName={(e) => createUserName(e)}
                        findAuthor={(e) => findAuthor(e)}
                      />
                    );
                  }}
                />
              </CardBody>
            </div>

            {/* <Editor
              toolbar={toolbar}
              editorState={editorState}
              onEditorStateChange={onEditorStateChange}
              onContentStateChange={onContentStateChange}
              editorStyle={{ height: "300px", padding: "5px" }}
              toolbarStyle={{ direction: "ltr !important" }}
              wrapperStyle={{ direction: "ltr" }}
            /> */}

            {data.GetTicket[0].status !== "closed" ? (
              <>
                <CKEditor
                  style={{ direction: "rtl" }}
                  editor={ClassicEditor}
                  data={contentState}
                  // onReady={(editor) => {
                  //   // You can store the "editor" and use when it is needed.
                  //   console.log("Editor is ready to use!", editor);
                  // }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log({ event, editor, data });
                    setContentState(data);
                  }}
                  // onBlur={(event, editor) => {
                  //   console.log("Blur.", editor);
                  // }}
                  // onFocus={(event, editor) => {
                  //   console.log("Focus.", editor);
                  // }}
                />
                <Button
                  block
                  color="success"
                  className="mt-4"
                  onClick={() => {
                    createTicket({
                      variables: {
                        ticketInput: {
                          ticket_id: parseInt(
                            window.location.hash.split("/")[2]
                          ),
                          content: contentState,
                          created: new Date(),
                          status: user_role === "admin" ? "answered" : "open",
                        },
                      },
                    });
                  }}
                >
                  {lang_choiced.pages.tickets.ticket.btnSend}
                </Button>
              </>
            ) : (
              ""
            )}
          </CardBody>
        </Card>
      </div>
    );
  }
};

export default Ticket;
